import { Entity } from "typegraph";
import Field from "typegraph/dist/decorators/field/Field";
import User from "./User";

@Entity({many: "userSubscriptions"})
export class  Followers {

	@Field()
	id: number;

	@Field({entity: User})
    user: User;
}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/Followers.ts